export default __webpack_public_path__ + "static/media/ic_trinidad_and_tobago.d904d8ae.svg";